import { useCallback, useMemo, useState } from 'react'

function normalizeImageSrc(src?: string | null): string | null {
  if (src == null) return null
  const trimmed = src.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function useEntityImagePreview(src?: string | null) {
  const url = useMemo(() => normalizeImageSrc(src), [src])
  const [open, setOpen] = useState(false)
  const canPreview = url != null

  const openPreview = useCallback(() => {
    if (url == null) return
    setOpen(true)
  }, [url])

  const closePreview = useCallback(() => {
    setOpen(false)
  }, [])

  return {
    canPreview,
    openPreview,
    closePreview,
    galleryImages: url != null ? [url] : null,
    galleryOpen: open,
  }
}
